export default __webpack_public_path__ + "static/media/presentation.d530cd85.pptx";